import React from "react";
import { connect } from "react-redux";
import { currentWidget, openSMSWidget } from "../../../action/action";
import { CMSPath } from "../../../config/constant";

export const SendSMSFloatingWidget = (props) => {

    const handleOpenSMSWidget = () => {
        props.currentWidget(props.widgetInfo);
        props.openSMSWidget(true);
    }

    return (
        <>
        { this.props.floatingWidgetRenderType === "BOTTOM_DOCKED" ? (
            <div>
                <a onClick={() => handleOpenSMSWidget()} class="tile-container" style={{ backgroundColor: props.menuColor.assetBackgroundSelectorColor }} >
                    {this.props.widgetInfo.btnImageUrl ?
                        <span class="button-icon">
                            <img src={`${CMSPath}${this.props.widgetInfo.btnImageUrl}`} />
                        </span> 
                        : <i class="fas fa-comment"></i>
                    }
                    <span class="button-icon">{this.props.widgetInfo.displayName}</span>
                </a>
            </div> 
        ) : (
            <div class="chatbox">
                <a onClick={() => handleOpenSMSWidget()} class="tile-container" style={{ backgroundColor: props.menuColor.assetBackgroundSelectorColor }} >
                    {this.props.widgetInfo.btnImageUrl ?
                        <span class="button-icon">
                            <img src={`${CMSPath}${this.props.widgetInfo.btnImageUrl}`} />
                        </span> 
                        : <i class="fas fa-comment-alt"></i>
                    }
                </a>
            </div>
        )}
        </>
    )
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        floatingWidgetRenderType : state.store.home.currentDuration.floatingWidgetRenderType ? state.store.home.currentDuration.floatingWidgetRenderType : null,
    }
}

export default connect(mapStateToProps, {currentWidget, openSMSWidget})(SendSMSFloatingWidget);
